'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _isString2 = require('lodash/isString');

var _isString3 = _interopRequireDefault(_isString2);

var _isBoolean2 = require('lodash/isBoolean');

var _isBoolean3 = _interopRequireDefault(_isBoolean2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _component = require('react-pure-render/component');

var _component2 = _interopRequireDefault(_component);

var _layout = require('../layout');

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _loadingSpinner = require('../loading-spinner');

var _loadingSpinner2 = _interopRequireDefault(_loadingSpinner);

var _button = require('./button.css');

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ICON_SIZE = {
  small: '14',
  medium: '18',
  large: '24'
};

function renderIcon(icon, border, size) {
  var _cx, _cx2;

  if (!icon) return null;

  return (0, _isString3.default)(icon) ? _react2.default.createElement(
    'span',
    {
      className: (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, _button2.default.icon, true), (0, _defineProperty3.default)(_cx, _button2.default.border, border), _cx))
    },
    _react2.default.createElement(
      _icon2.default,
      { size: !!size ? size : '18' },
      icon
    )
  ) : _react2.default.createElement(
    'span',
    {
      className: (0, _classnames2.default)((_cx2 = {}, (0, _defineProperty3.default)(_cx2, _button2.default.icon, true), (0, _defineProperty3.default)(_cx2, _button2.default.border, border), _cx2))
    },
    icon
  );
}

var Button = function (_PureComponent) {
  (0, _inherits3.default)(Button, _PureComponent);

  function Button() {
    (0, _classCallCheck3.default)(this, Button);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this));

    _this.state = {
      loaded: false
    };
    return _this;
  }

  (0, _createClass3.default)(Button, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.__loadedTimeout__) {
        clearTimeout(this.__loadedTimeout__);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.props.loading && !nextProps.loading) {
        this.setState({ loaded: true });
        clearTimeout(this.__loadedTimeout__);
        this.__loadedTimeout__ = setTimeout(function () {
          if (_this2.state.loaded) {
            _this2.setState({ loaded: false });
          }
        }, this.props.loadedTimeout);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _cx3, _cx4, _cx5;

      var _props = this.props,
          children = _props.children,
          disabled = _props.disabled,
          icon = _props.icon,
          reverse = _props.reverse,
          iconBorder = _props.iconBorder,
          loneIcon = _props.loneIcon,
          theme = _props.theme,
          grouped = _props.grouped,
          spacing = _props.spacing,
          size = _props.size,
          active = _props.active,
          wide = _props.wide,
          onClick = _props.onClick,
          loading = _props.loading,
          success = _props.success,
          message = _props.message,
          name = _props.name,
          flex = _props.flex,
          type = _props.type,
          role = _props.role,
          Component = _props.component,
          className = _props.className,
          middle = _props.middle,
          style = _props.style,
          mayGetLong = _props.mayGetLong,
          subdued = _props.subdued,
          _IGNORED = _props.loadedTimeout,
          __IGNORED = _props.readonly,
          ___IGNORED = _props.editable,
          otherProps = (0, _objectWithoutProperties3.default)(_props, ['children', 'disabled', 'icon', 'reverse', 'iconBorder', 'loneIcon', 'theme', 'grouped', 'spacing', 'size', 'active', 'wide', 'onClick', 'loading', 'success', 'message', 'name', 'flex', 'type', 'role', 'component', 'className', 'middle', 'style', 'mayGetLong', 'subdued', 'loadedTimeout', 'readonly', 'editable']);
      var loaded = this.state.loaded;


      var Tag = this.props.to || this.props.href ? 'span' : 'button';

      var iconElement = renderIcon(icon, (0, _isBoolean3.default)(iconBorder) ? iconBorder : !!icon && !!children, ICON_SIZE[size]);

      var handleClick = function handleClick(event) {
        // Prevent form submit events propagating if button is mid-request
        if (loading || disabled) {
          event.preventDefault();
          return;
        }
        if (onClick) {
          onClick(event);
        }
      };

      return _react2.default.createElement(
        Component,
        (0, _extends3.default)({
          style: style,
          className: (0, _classnames2.default)((_cx3 = {}, (0, _defineProperty3.default)(_cx3, _button2.default.root, true), (0, _defineProperty3.default)(_cx3, _button2.default.grouped, !!grouped), (0, _defineProperty3.default)(_cx3, _button2.default.spacing, !!spacing), (0, _defineProperty3.default)(_cx3, _button2.default.wide, wide), (0, _defineProperty3.default)(_cx3, _button2.default.middle, middle), (0, _defineProperty3.default)(_cx3, _button2.default.loading, loading), (0, _defineProperty3.default)(_cx3, _button2.default.success, success), (0, _defineProperty3.default)(_cx3, _button2.default.loaded, loaded), (0, _defineProperty3.default)(_cx3, _button2.default.flex, flex), (0, _defineProperty3.default)(_cx3, _button2.default.reverse, reverse), _cx3), className),
          onClick: handleClick
        }, otherProps),
        _react2.default.createElement(
          Tag,
          {
            role: role,
            name: name,
            type: type,
            className: (0, _classnames2.default)((_cx4 = {}, (0, _defineProperty3.default)(_cx4, _button2.default.button, true), (0, _defineProperty3.default)(_cx4, _button2.default.disabled, success ? false : disabled || loading), (0, _defineProperty3.default)(_cx4, _button2.default[theme], !!theme), (0, _defineProperty3.default)(_cx4, _button2.default.active, !!active), (0, _defineProperty3.default)(_cx4, _button2.default.subdued, !!subdued), (0, _defineProperty3.default)(_cx4, _button2.default[size], true), (0, _defineProperty3.default)(_cx4, _button2.default.loneIcon, loneIcon), _cx4))
          },
          _react2.default.createElement(
            _layout.Flex,
            {
              alignItems: 'center',
              justifyContent: 'center',
              className: _button2.default.placeholder
            },
            iconElement,
            children
          ),
          _react2.default.createElement(
            _layout.Flex,
            {
              alignItems: 'center',
              justifyContent: 'center',
              name: 'message',
              className: (0, _classnames2.default)((_cx5 = {}, (0, _defineProperty3.default)(_cx5, _button2.default.message, true), (0, _defineProperty3.default)(_cx5, _button2.default.mayGetLong, mayGetLong), _cx5)),
              title: mayGetLong ? children : undefined
            },
            iconElement,
            children
          ),
          _react2.default.createElement(
            _layout.Flex,
            {
              alignItems: 'center',
              justifyContent: 'center',
              className: _button2.default.successMessage
            },
            iconElement,
            message
          ),
          _react2.default.createElement(
            'div',
            { className: _button2.default.loadingSpinner },
            _react2.default.createElement(_loadingSpinner2.default, { size: 'small' })
          )
        )
      );
    }
  }]);
  return Button;
}(_component2.default);

Button.propTypes = {
  children: _propTypes2.default.any,
  message: _propTypes2.default.string,
  role: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  icon: _propTypes2.default.any,
  iconBorder: _propTypes2.default.bool,
  loneIcon: _propTypes2.default.bool,
  wide: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  theme: _propTypes2.default.oneOf(['primary', 'secondary', 'tertiary', 'disabled', 'delete', 'deny', 'confirm']),
  grouped: _propTypes2.default.bool,
  spacing: _propTypes2.default.bool,
  flex: _propTypes2.default.bool,
  active: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  success: _propTypes2.default.bool,
  middle: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  loadedTimeout: _propTypes2.default.number,
  component: _propTypes2.default.any,
  name: _propTypes2.default.string,
  type: _propTypes2.default.string,
  mayGetLong: _propTypes2.default.bool,
  subdued: _propTypes2.default.bool
};
Button.defaultProps = {
  role: 'button',
  size: 'large',
  theme: 'primary',
  iconBorder: false,
  wide: false,
  loading: false,
  loneIcon: false,
  loadedTimeout: 600,
  component: _layout.Box
};
exports.default = Button;


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/button/button.js
// module id = 310
// module chunks = 114276838955818